import { Component, OnInit, forwardRef } from '@angular/core';
import { NavController, NavParams, ActionSheetController, ModalController, AlertController, ToastController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { GrupoAdmHorarioAddPage } from '../grupo-adm-horario-add/grupo-adm-horario-add.page';
import { GrupoProvider } from 'src/app/services/grupo/grupo';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NomenclaturaPipe } from 'src/app/pipes/nomenclatura/nomenclatura';
import { SemRegistroComponent } from 'src/app/components/sem-registro/sem-registro';

@Component({
  selector: 'app-grupo-adm-horario',
  templateUrl: './grupo-adm-horario.page.html',
  styleUrls: ['./grupo-adm-horario.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NomenclaturaPipe,
    TranslateModule,
    SemRegistroComponent
  ],
})
export class GrupoAdmHorarioPage implements OnInit {
  idGrupo: any;
  horarioList: any = [];
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private translate: TranslateService,
    public actionSheetCtrl: ActionSheetController,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    public grupoProvider: GrupoProvider
  ) {
    this.idGrupo = this.navParams.get('id');

    this.grupoProvider.getGrupoHorario(this.idGrupo).subscribe((data) => {
      this.horarioList = data;
    });
  }

  ngOnInit() {
  }

  getDiaSemana(dia: any) {

    switch (dia) {
      case 1:
        return this.translate.instant('Domingo');
      case 2:
        return this.translate.instant('Segunda-Feira');
      case 3:
        return this.translate.instant('Terça-Feira');
      case 4:
        return this.translate.instant('Quarta-Feira');
      case 5:
        return this.translate.instant('Quinta-Feira');
      case 6:
        return this.translate.instant('Sexta-Feira');
      case 7:
        return this.translate.instant('Sábado');

      default:
        return this.translate.instant('Não Informado');
    }

  }

  getHorario(hora: string) {
    return hora.substr(0, 2) + ':' + hora.substr(2, 2);
  }

  async selecionarHorario(horario: { id: any; }) {
    let actionSheet = await this.actionSheetCtrl.create({
      header: this.translate.instant('Opções'),
      buttons: [
        {
          text: this.translate.instant('Editar'),
          handler: async () => {
            var data = { horario: horario, id: horario.id, idGrupo: this.idGrupo };
            const modalPage = await this.modalCtrl.create({ component: GrupoAdmHorarioAddPage, componentProps: data });
            modalPage.present();

            (await modalPage.onDidDismiss()).data
            this.grupoProvider.getGrupoHorario(this.idGrupo).subscribe((data) => {
              this.horarioList = data;
            });
          }
        },
        {
          text: this.translate.instant('Remover'),
          handler: async () => {
            let alert = await this.alertCtrl.create({
              cssClass: "alerta-personalizado",
              mode: "ios",
              header: this.translate.instant('Atenção'),
              message: this.translate.instant('Confirma exclusão de horário?'),
              buttons: [
                {
                  text: this.translate.instant('Não'),
                  handler: () => { }
                },
                {
                  text: this.translate.instant('Sim'),
                  handler: () => {
                    this.grupoProvider.removerHorario(horario.id).subscribe(async data => {
                      this.grupoProvider.getGrupoHorario(this.idGrupo).subscribe((data) => {
                        this.horarioList = data;
                      });

                      const toast = await this.toastCtrl.create({
                        message: this.translate.instant('Horário removido sucesso!'),
                        duration: 3000
                      });

                      toast.present();
                    });
                  }
                }
              ]
            });
            alert.present();
          }
        },
      ]
    });

    actionSheet.present();
  }

  async addHorario() {
    const modalPage = await this.modalCtrl.create({ component: GrupoAdmHorarioAddPage, componentProps: { idGrupo: this.idGrupo } });
    modalPage.present();

    const data = (await modalPage.onDidDismiss())
    this.grupoProvider.getGrupoHorario(this.idGrupo).subscribe((data) => {
      this.horarioList = data;
    });
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
